// extracted by mini-css-extract-plugin
export default {"btn":"SecondaryButton_btn__Kbw-d","uppercase":"SecondaryButton_uppercase__iFXd5","bold":"SecondaryButton_bold__9-aUO","disabled":"SecondaryButton_disabled__2-JcW"};